var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInclusivity = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "inclusivity_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  mask: "url(#inclusivity_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.4 18.4H3V36h6.4V18.4ZM27 6c1.04-1.216 2.656-2 4.32-2 2.96 0 5.28 2.32 5.28 5.28 0 3.632-4.656 7.84-9.6 12.32-4.944-4.496-9.6-8.704-9.6-12.32C17.4 6.32 19.72 4 22.68 4c1.664 0 3.28.784 4.32 2ZM36.6 28H22.2l-3.344-1.168.528-1.52L22.2 26.4h6.4v-3.2l-12.848-4.8H12.6v14.432L23.8 36l12.8-4.8V28Z"
}))));
export default SvgInclusivity;